module.exports = __webpack_public_path__ + "officialStatic/img/case47.5c0f048.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case47.jpg
// module id = LGAo
// module chunks = 0